import Vue from "vue";
import App from "@/App.vue";
import VueRouter from "vue-router";

import user from "@/user";
import store from "@/store";
import tracker from "@/tracker";
import couplesRouter from "@/couples/router";
import BlankLayout from "@/layout/Blank";
import BorderedPageLayout from "@/layout/BorderedPage";

Vue.config.productionTip = false;

Vue.component("BlankLayout", BlankLayout);
Vue.component("BorderedPageLayout", BorderedPageLayout);

Vue.use(VueRouter);
Vue.use(user);
Vue.use(store);
Vue.use(tracker);

new Vue({
  router: couplesRouter,
  render: (h) => h(App),
}).$mount("#app");
